import React from "react"
import { useLocation } from "react-router-dom"
import ScreenLayout from "./ScreenLayout"
import { LegacyScreenHost, useRoute } from "./navigation"
import useNavigation from "~hooks/useNavigation"
import { resolveScreenOptions, resolveScreenTitle, type AppScreenOptions } from "./screen-options"
import { getPcPresentationForPath } from "./pc-presentation"

export function ConfiguredLegacyScreen({
  name,
  component,
  options,
}: {
  name: string
  component: React.ComponentType<{ route?: ReturnType<typeof useRoute>; navigation?: ReturnType<typeof useNavigation> }>
  options?: AppScreenOptions
}) {
  const route = useRoute()
  const navigation = useNavigation()
  const location = useLocation()
  const ctx = { navigation, route: { params: route.params as Record<string, unknown> | undefined } }
  const resolved = resolveScreenOptions(options, ctx)
  const title = resolveScreenTitle(name, options, ctx)
  const headerShown = resolved.headerShown !== false
  const pcPresentation = getPcPresentationForPath(location.pathname)

  if (pcPresentation) {
    return <LegacyScreenHost component={component} />
  }

  return (
    <ScreenLayout
      title={title}
      headerShown={headerShown}
      headerBackVisible={resolved.headerBackVisible}
      configHeaderRight={resolved.headerRight}
    >
      <LegacyScreenHost component={component} />
    </ScreenLayout>
  )
}
